module.exports = { "default": require("core-js/library/fn/math/trunc"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/trunc.js
// module id = INCx
// module chunks = 8